<template>
  <div>
    <div class="flex flex-wrap lg:flex-no-wrap">
      <div class="bg-gray-100 rounded w-full lg:w-1/2 shadow p-4 mb-4 lg:mr-2">
        <div class="form-group">
          <label class="form-label">Rechnungsnummer</label>
          <input type="text" name="invoice_number" class="input" v-model="invoice.invoice_number"
                 v-bind:class="{ 'input-error': errors.invoice_number }"/>
          <div class="input-error-message" v-if="errors.invoice_number">{{ errors.invoice_number[0] }}</div>
        </div>
        <div class="form-group">
          <label class="form-label">Rechnungsname</label>
          <input type="text" name="invoice_name" class="input" v-model="invoice.invoice_name"
                 v-bind:class="{ 'input-error': errors.invoice_name }"/>
          <div class="input-error-message" v-if="errors.invoice_name">{{ errors.invoice_name[0] }}</div>
        </div>
        <div class="form-group">
          <label class="form-label">Rechnungsdatum</label>
          <date-picker v-model="invoice.date" valueType="format" format="DD.MM.YYYY"></date-picker>
          <div class="input-error-message" v-if="errors.date">{{ errors.date[0] }}</div>
        </div>
        <div class="flex">
          <div class="form-group pr-4">
            <label class="form-label">Leistungszeitraum Start</label>
            <date-picker v-model="invoice.start_date" valueType="format" format="DD.MM.YYYY"></date-picker>
            <div class="input-error-message" v-if="errors.start_date">{{ errors.start_date[0] }}</div>
          </div>
          <div class="form-group">
            <label class="form-label">Leistungszeitraum Ende</label>
            <date-picker v-model="invoice.end_date" valueType="format" format="DD.MM.YYYY"
                         v-bind:class="{ 'input-error': errors.end_date }"></date-picker>
            <div class="input-error-message" v-if="errors.end_date">{{ errors.end_date[0] }}</div>
          </div>
        </div>
      </div>
      <div class="bg-gray-100 rounded w-full lg:w-1/2 shadow p-4 mb-4 lg:ml-2">
        <h3 class="font-bold mb-2">Adresse</h3>
        <div class="flex">
          <div class="form-group pr-4 flex-grow-1">
            <label class="form-label">Anrede</label>
            <input type="text" name="salutation" class="input w-full" v-model="invoice.salutation"
                   v-bind:class="{ 'input-error': errors.salutation }"/>
            <div class="input-error-message" v-if="errors.salutation">{{ errors.salutation[0] }}</div>
          </div>
          <div class="form-group flex-grow-3">
            <label class="form-label">Name</label>
            <input type="text" name="name" class="input w-full" v-model="invoice.name"
                   v-bind:class="{ 'input-error': errors.name }"/>
            <div class="input-error-message" v-if="errors.name">{{ errors.name[0] }}</div>
          </div>
        </div>
        <div class="form-group ">
          <label class="form-label">Strasse und Hausnummer</label>
          <input type="text" name="street" class="input w-full" v-model="invoice.street"
                 v-bind:class="{ 'input-error': errors.street }"/>
          <div class="input-error-message" v-if="errors.street">{{ errors.street[0] }}</div>
        </div>
        <div class="flex">
          <div class="form-group pr-4 flex-grow-1">
            <label class="form-label">PLZ</label>
            <input type="text" name="zip" class="input w-full" v-model="invoice.zip"
                   v-bind:class="{ 'input-error': errors.zip }"/>
            <div class="input-error-message" v-if="errors.zip">{{ errors.zip[0] }}</div>
          </div>
          <div class="form-group flex-grow-3">
            <label class="form-label">Stadt</label>
            <input type="text" name="city" class="input w-full" v-model="invoice.city"
                   v-bind:class="{ 'input-error': errors.city }"/>
            <div class="input-error-message" v-if="errors.city">{{ errors.city[0] }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end my-6">
      <button v-on:click="saveInvoice" class="btn btn-primary">Speichern</button>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';
import moment from 'moment';

export default {
  components: {DatePicker},
  props: [
    'actionUrl',
    'method',
    'initialInvoice',
  ],
  data() {
    return {
      invoice: JSON.parse(this.initialInvoice),
      errors: [],
    }
  },
  methods: {
    saveInvoice: function () {
      this.invoice.invoice_items_attributes = this.invoiceItems;
      this.$http[this.method](this.actionUrl, {invoice: this.invoice}).then(response => {
        console.log(response)
        window.location.href = response.body.html_path
      }, response => {
        console.log(response)
        if (response.status = 422) {
          this.errors = response.body;
        }
      })
    },
  },

  mounted: function () {
    this.invoice.date = moment(this.invoice.date, "YYYY-MM-DD").format("DD.MM.YYYY");
    this.invoice.start_date = moment(this.invoice.start_date, "YYYY-MM-DD").format("DD.MM.YYYY");
    this.invoice.end_date = moment(this.invoice.end_date, "YYYY-MM-DD").format("DD.MM.YYYY");
  }
}
</script>
